export default "__VITE_ASSET__BpxDrBcy__"